import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../pages/context/AppContext.jsx";
import "./style.css";

import SaldoIcon from "../../assets/sidebar/saldo.png";
import CategoriaIcon from "../../assets/sidebar/categoria.png";
import PessoaIcon from "../../assets/sidebar/pessoa.png";
import MetaIcon from "../../assets/sidebar/meta.png";
import LogoutIcon from "../../assets/sidebar/deslogar.png";

function Sidebar({ aberto, fechar }) {

  const navigate = useNavigate();
  const { logout } = useAppContext();

  const irPara = (rota) => {
    navigate(rota);
    fechar();
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      {/* OVERLAY */}
      <div
        className={`sidebar-overlay ${aberto ? "ativo" : ""}`}
        onClick={fechar}
      ></div>

      {/* SIDEBAR */}
      <div className={`sidebar ${aberto ? "ativo" : ""}`}>

        {/* HEADER */}
        <div className="sidebar-header">
          <div className="sidebar-header-left">
            <h4>iContas</h4>
            <span>Gerencie sua vida financeira</span>
          </div>

          {/* BOTÃO FECHAR (IMPORTANTE PARA MOBILE) */}
          <button className="sidebar-close" onClick={fechar}>
            ✕
          </button>
        </div>

        <div className="sidebar-list">

          <div className="sidebar-item" onClick={() => irPara("/saldo")}>
            <img src={SaldoIcon} alt="Saldos" />
            <div>
              <strong>Saldos</strong>
              <small>
                Seus saldos, seja pessoal, conta corrente ou poupança/investimento.
              </small>
            </div>
          </div>

          <div className="sidebar-item" onClick={() => irPara("/categoria")}>
            <img src={CategoriaIcon} alt="Categorias" />
            <div>
              <strong>Categorias</strong>
              <small>
                Suas categorias financeiras, uma forma de organizar suas entradas e saídas.
              </small>
            </div>
          </div>

          <div className="sidebar-item" onClick={() => irPara("/pessoa")}>
            <img src={PessoaIcon} alt="Pessoas" />
            <div>
              <strong>Pessoas</strong>
              <small>
                Os responsáveis pela movimentação financeira.
              </small>
            </div>
          </div>

          <div className="sidebar-item" onClick={() => irPara("/meta")}>
            <img src={MetaIcon} alt="Metas" />
            <div>
              <strong>Metas</strong>
              <small>
                Monte as suas metas por categoria, para assim ter o auxílio da gestão das suas contas.
              </small>
            </div>
          </div>

        </div>

        <div className="sidebar-footer">
          <div className="sidebar-item logout" onClick={handleLogout}>
            <img src={LogoutIcon} alt="Deslogar" />
            <div>
              <strong>Deslogar</strong>
              <small>
                Para sair do app, e ser redirecionado para o login.
              </small>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default Sidebar;